import { render, staticRenderFns } from "./Ascription.vue?vue&type=template&id=7731119a&scoped=true&"
import script from "./Ascription.vue?vue&type=script&lang=js&"
export * from "./Ascription.vue?vue&type=script&lang=js&"
import style0 from "./Ascription.vue?vue&type=style&index=0&id=7731119a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7731119a",
  null
  
)

export default component.exports